<template>
  <app-tooltip v-if="paymentMethod">
    <img
      :alt="paymentMethod.label + ' logo'"
      class="payment-method__logo"
      :src="paymentMethod.image"
    >

    <template #popper>
      <p>{{ paymentMethod.label }}</p>
    </template>
  </app-tooltip>
</template>

<script setup>
import { computed } from 'vue'
import { usePaymentProfileStore } from '@/stores/PaymentProfileStore'

import AppTooltip from '&/atoms/AppTooltip'

const { payment_methods } = usePaymentProfileStore()

const { type } = defineProps({
  type: { type: String, required: true },
  size: { type: Number, default: 2.5 }
})
const paymentMethod = computed(() => payment_methods.find(payment_method => payment_method.value === type))
</script>

<style scoped lang="scss">
.payment-method {
  &__logo {
    width: calc(v-bind(size) * 12px);
  }
}
</style>
